import { render, staticRenderFns } from "./intellidataDeviceIORecord.vue?vue&type=template&id=9b89f128&scoped=true"
import script from "./intellidataDeviceIORecord.vue?vue&type=script&lang=js"
export * from "./intellidataDeviceIORecord.vue?vue&type=script&lang=js"
import style0 from "./intellidataDeviceIORecord.vue?vue&type=style&index=0&id=9b89f128&prod&scoped=true&lang=css"
import style1 from "./intellidataDeviceIORecord.vue?vue&type=style&index=1&id=9b89f128&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b89f128",
  null
  
)

export default component.exports